export default __webpack_public_path__ + "5cfcb156295fa4ef05949d38149aff67.svg";